import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import {  provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlagBasedPreloadingStrategy } from './strategy/flag-based.preloading-strategy';
// import { LoaderInterceptor } from './core/interceptors/loader/loader.interceptor';


export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(FlagBasedPreloadingStrategy)),
    provideClientHydration(),
    importProvidersFrom(
      BrowserAnimationsModule,
      BrowserModule,
      ToastrModule.forRoot({
        timeOut: 4000,
        positionClass: 'toast-top-center',
        preventDuplicates: true,
        progressBar: true,
        closeButton:true
      })
    ),
  ].filter((provider): provider is Exclude<typeof provider, undefined> => provider !== undefined),
};
